import { login } from "@lib/data/customer"
import { LOGIN_VIEW } from "@modules/account/templates/login-template"
import ErrorMessage from "@modules/checkout/components/error-message"
import { SubmitButton } from "@modules/checkout/components/submit-button"
import Input from "@modules/common/components/input"
import { useActionState } from "react"

type Props = {
  setCurrentView: (view: LOGIN_VIEW) => void
}

const Login = ({ setCurrentView }: Props) => {
  const [message, formAction] = useActionState(login, null)

  return (
    <div
      className="max-w-sm w-full flex flex-col items-center"
      data-testid="login-page"
    >
      <h1 className="text-large-semi uppercase mb-6">Hola de nuevo</h1>
      <p className="text-center text-base-regular text-ui-fg-base mb-8">
        Identificate para disfrutar de una mejor experiencia de compra.
      </p>
      {message?.state === "verification_required" && (
        <div
          className="w-full mb-6 text-center text-base-regular text-ui-fg-base bg-ui-bg-subtle border border-ui-border-base rounded-rounded p-4"
          data-testid="login-verification-message"
        >
          Te hemos enviado un enlace de verificacion a <strong>{message.email}</strong>.
          Verifica tu email y despues inicia sesion.
        </div>
      )}
      <form className="w-full" action={formAction}>
        <div className="flex flex-col w-full gap-y-2">
          <Input
            label="Correo electronico"
            name="email"
            type="email"
            title="Introduce un email valido."
            autoComplete="email"
            required
            data-testid="email-input"
          />
          <Input
            label="Contrasena"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            data-testid="password-input"
          />
        </div>
        <ErrorMessage
          error={message?.state === "error" ? message.error : null}
          data-testid="login-error-message"
        />
        <SubmitButton data-testid="sign-in-button" className="w-full mt-6">
          Iniciar sesion
        </SubmitButton>
      </form>
      <button
        onClick={() => setCurrentView(LOGIN_VIEW.FORGOT_PASSWORD)}
        className="underline text-small-regular mt-4"
        data-testid="forgot-password-button"
      >
        He olvidado mi contrasena
      </button>
      <span className="text-center text-ui-fg-base text-small-regular mt-6">
        No tienes cuenta?{" "}
        <button
          onClick={() => setCurrentView(LOGIN_VIEW.REGISTER)}
          className="underline"
          data-testid="register-button"
        >
          Crea tu cuenta Zeio Labs
        </button>
        .
      </span>
    </div>
  )
}

export default Login
